<template>
  <view class="pft-table-component__row">
    <template v-if="sumConfig?.length">
      <view
        class="pft-table-component__body__cell"
        v-for="(sumItem, index) in sumConfig"
        :class="itemClass(index, row?.rank as number)"
        :key="index"
        :style="sumItem.style"
      >
        <template v-if="sumItem.type === 'text'">
          <text class="text">{{ sumItem.text }}</text>
        </template>
        <template v-else-if="sumItem.type === 'sum'">
          <text class="text">{{ sumColumn(sumItem.key!, sumItem.format!) }}</text>
        </template>
      </view>
    </template>
  </view>
</template>

<script lang="ts" setup>
import { inject } from "vue"

const props = defineProps<{
  row?: any
}>()

const sumConfig = inject("sumConfig") as any[]
const sumColumn = inject("sumColumn") as (key: string, format: string) => string
const itemClass = inject("itemClass") as (index: number, rank: number) => string
</script>

<style lang="scss" scoped>
.pft-table-component__row {
  display: grid;
  grid-template-columns: var(--GRID-ROW-TEMPLATE-COLUMNS);
}
</style>
